<template>
  <div class="body-wrapper">
    <QuestionImage
        :attaches="questionData?.content?.attach
    ?.filter(item => item.file?.attachUrl)
    ?.map(item => ({ attachUrl: item.file.attachUrl })) || []"
    />
    <h5 class="title">
      {{ questionData?.name }}
    </h5>

    <div class="grading-container">
      <span>Please rate your answer</span>
      <input type="range" min="1" max="10" value="5">
    </div>
  </div>
</template>

<script>
import QuestionImage from "@/components/QuestionImage.vue";

export default{
  components: {QuestionImage},
  props:{
    questionData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 10px;
  z-index: 1;
}

.title {
  font-size: 18px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_semi_bold, sans-serif;
}

.grading-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 8px;
  margin-top: 20px;
}

.grading-container span {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 20px;
  font-family: euclid_medium, sans-serif;
}

input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  background: linear-gradient(90deg, #bed8e2, #b4c0a5, #fb7f43, #a84383, #6943ce);
  border-radius: 4px;
  outline: none;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  background: #ffffff;
  border: 4px solid #d1d6df;
  border-radius: 50%;
  cursor: pointer;
}
</style>
